import { render, staticRenderFns } from "./transfer_modal.vue?vue&type=template&id=3e4bb9a8&vue3"
import script from "./transfer_modal.vue?vue&type=script&lang=js&vue3"
export * from "./transfer_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports